import { struct as l } from "../../../utils/struct/main.js";
import { getter as p, enumerable as t } from "../../../utils/struct/property.js";
import { noop as u } from "../../../utils/common.js";
const _ = () => {
  let o, s, r;
  const m = () => {
    const e = r ?? u, c = new Promise((f, i) => {
      r = f, s = i;
    });
    return e(o = c), n;
  }, n = l({
    promise: p(() => o),
    refresh: t(m),
    reject: t((e) => s(e)),
    resolve: t((e) => r(e))
  });
  return m();
};
export {
  _ as createDeferred,
  _ as default
};
